module.exports = __webpack_public_path__ + "img/mc.2e77fe06.svg";